import React from 'react';
import { connect } from 'react-redux';
import { Button, Glyphicon, Modal } from 'react-bootstrap';
import { fromJS, Map, List } from 'immutable';
import Select from 'react-select';
import { formatNumber, formatQuantity } from '../elements/BaseElement';
import {
  addRouteSubElement,
  deleteMultiNodalRoute,
  updateDealProductField,
  updateMultiNodalFieldField,
  deleteLink,
} from '../store/deal.store';
import { handleFormChanged } from '../../../../store/allaround.store';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { dateTimePickerFormat } from '@/util/util.jsx';
import { ButtonWithFuncBound, DateTimePicker2 as DateTimePicker }
  from '@/component/form/FormControls.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import { formatTransportName } from '../transport/SmallTransportDisplay';
import FancyInput from '@/component/form/numinput/index.jsx';
import { Checkbox, FormControl } from '../../../form/FormControls';
import RefPicker from '@/component/dict/simple/select/DictPicker.jsx';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import vessel from '@/../style/vesselbtn.png';
import './multiNodalTabStyle.css';
import { saveProductToLinkIdx, saveProductToLinkTransportIdx, saveLinkIdxToAssignTransport }
  from '../../../../store/links.store';
import trash from '../../../../../style/trash.png';

moment.locale('en');
momentLocalizer();

const expandHack = [];
expandHack.indexOf = () => 0;

export const getArrival = (shipmentStart, voyageNumber) => {
  if (shipmentStart) {
    const arrival = moment(shipmentStart, dateTimePickerFormat);
    if (voyageNumber) {
      return moment(arrival).add(voyageNumber, 'd');
    }
    return arrival;
  }
  return null;
};

export class MultiNodalRouteTable extends React.PureComponent {
  state = {
    showModalDeleteRoute: false,
    showModalDeleteNode: false,
    idxToDelete: undefined,
  }
  closeModalDeleteRoute = () => this.setState({
    showModalDeleteRoute: false, idxToDelete: undefined,
  })
  closeModalDeleteNode = () => this.setState({ showModalDeleteNode: false })
  showModalDeleteRoute = () => this.setState({ showModalDeleteRoute: true })
  showModalDeleteNode = (idxToDelete) => this.setState({ showModalDeleteNode: true, idxToDelete })

  getParentIdxChain = () => this.props.parentIdxChain || [];

  getFieldPath = (idx, popLast) => {
    const chain = this.getParentIdxChain();
    if (idx || idx === 0) {
      chain.push(idx);
    }
    const result = chain.join(', elements, ').split(', ').filter(el => el !== '');
    if (popLast) {
      result.pop();
    }
    return result;
  }

  handleAddNode = () => {
    this.props.updateRouteRecalc(
      this.props.data.push(
        new Map({
          creationDate: new Date().getTime(),
          quantity: this.props.data.get(0, new Map()).get('quantity'),
          currency: this.props.data.get(0, new Map()).get('currency') || 'USD',
        }),
      ), this.getFieldPath());
  }

  handleDeleteNode = () => {
    this.props.updateRouteRecalc(
      this.props.data.delete(this.state.idxToDelete),
      this.getFieldPath(this.state.idxToDelete, true)
    );
    this.closeModalDeleteNode();
  };

  handleDeleteRoute = () => {
    this.props.deleteMultiNodalRoute(this.getFieldPath());
    this.closeModalDeleteRoute();
  };

  handleChangeRoute = (idx, field, value) => {
    this.props.handleFormChanged();
    this.props.updateRoute(
      this.props.data.set(idx, this.props.data.get(idx).set(field, value)),
      this.getFieldPath(idx, true),
    );
  }

  handleChangeRouteRecalc = (idx, field, value) => {
    this.props.handleFormChanged();
    this.props.updateRouteRecalc(
      this.props.data.set(idx, this.props.data.get(idx).set(field, value)),
      this.getFieldPath(idx, true)
    );
  };

  arrivalFormatter = (value, row) => {
    if (this.props.hasLinks) {
      return '';
    }
    const arrival = getArrival(row.shipmentStart, row.voyageNumber);
    if (arrival) {
      return arrival.format(dateTimePickerFormat);
    }
    return '';
  }

  dateFormatter = (date, row, field) => {
    if (this.props.hasLinks) {
      if (field === 'blDate') {
        const transport = this.getTransport(row);
        // eslint-disable-next-line
        date = row.billLadingDate || transport.get('billLandingDate')
          || transport.get('onBoardDate')
          || transport.get('vesselLoadingPorts', new List()).get(0, new Map())
            .get('billLandingDate');
        if (date) {
          return moment(new Date(date)).format(dateTimePickerFormat);
        }
      }
      return '';
    }
    return (<div className={'multinodal-date'}>
      <DateTimePicker
        component={DateTimePicker}
        time={false}
        format={dateTimePickerFormat}
        defaultValue={date ? new Date(date) : undefined}
        disabled={this.props.disabled}
        onChange={(e, val) => {
          this.handleChangeRoute(row.idx, field, val);
        }}
      />
    </div>);
  }

  costFormatter = (value, row, field) => {
    if (this.props.hasLinks) {
      return '';
    }
    return (<div className={'multinodal-cost'}>
      {field == 'costEstimated' && <div
        className="multinodal-currencyinput"
        key={row.currency}
      >
        <CurrencyInput
          name="dueAmountCurrency"
          defaultValue={row.currency}
          noRates
          disabled={this.props.disabled}
          onChange={(val) => {
            this.handleChangeRouteRecalc(row.idx, 'currency', val);
          }}
        />
      </div>}
      <FancyInput
        className="form-control"
        style={{ textAlign: 'right' }}
        fraction={2}
        positive
        negative={false}
        thousand
        disabled={this.props.disabled}
        type="number"
        value={parseFloat(row[field] || 0).toFixed(2)}
        onChange={(e, val) => {
          this.handleChangeRouteRecalc(row.idx, field, val);
        }}
      />
    </div>);
  }

  getTransport = (row) => {
    if (row.transport || row.transport === 0) {
      return this.props.transports.find(
        t => t.get('id') == row.transport, this, new Map());
    }
    return new Map();
  }

  textFormatter = (value, row, fieldName) => {
    if (this.props.hasLinks) {
      if (fieldName === 'carrier' && (row.transport || row.transport === 0)) {
        return formatTransportName(this.getTransport(row), true);
      }
      return '';
    }
    if (fieldName === 'destinationFrom' && this.props.parent) {
      return this.props.parent.destinationTo;
    }
    return (<FormControl
      value={value || undefined}
      disabled={this.props.disabled}
      onChange={(e) => {
        this.handleChangeRoute(row.idx, fieldName, e.target.value);
      }}
    />);
  };

  transportTypeFormatter = (value, row, fieldName) => {
    if (this.props.hasLinks) {
      return '';
    }
    return (<Select
      value={value}
      disabled={this.props.disabled}
      onChange={option => this.handleChangeRoute(row.idx, fieldName, option && option.value)}
      options={[
        { value: 'BULK', label: 'Bulk Vessel' },
        { value: 'CONTAINER', label: 'Container' },
        { value: 'RAILCAR', label: 'Railcar' },
        { value: 'TRUCK', label: 'Truck' },
      ]}
    />);
  }

  termFormatter = (value, row) => {
    if (this.props.hasLinks) {
      return '';
    }
    return (<RefPicker
      dict="deliveryterm"
      name="deliveryterm"
      updateDefValueOnEveryChange
      defaultValue={row ? row.term : undefined}
      disabled={this.props.disabled}
      onChangeFunc={val => {
        this.handleChangeRoute(row.idx, 'term', val ? val.value : undefined);
      }}
    />);
  }

  qtyFormatter = (value, row) => {
    if (this.props.hasLinks) {
      if (row.billLandingQuantity && parseInt(row.billLandingQuantity, 10) > 0) {
        return formatNumber(row.billLandingQuantity, '0,0.[000]');
      }
      return formatQuantity(row, true, false);
    }
    return (<FancyInput
      className="form-control"
      thousand
      fraction={3}
      positive
      negative={false}
      type="number"
      id="quantity" name="quantity"
      value={row.quantity
        ? row.quantity
        : ''}
      disabled={this.props.disabled}
      onChange={(elem, val) => this.handleChangeRoute(row.idx, 'quantity', val)}
    />);
  };

  voyageDaysFormatter = (value, row, fieldName) => {
    if (this.props.hasLinks) {
      return '';
    }
    return (<FancyInput
      className="form-control"
      thousand
      fraction={0}
      positive
      negative={false}
      type="number"
      value={value}
      disabled={this.props.disabled}
      onChange={(elem, val) => this.handleChangeRoute(
        row.idx, fieldName, val
      )}
    />);
  }

  finalDestinationFormatter = (value, row) => {
    if (this.props.hasLinks) {
      return '';
    }
    return (<Checkbox
      checked={value}
      onChange={(e) =>
        this.handleChangeRoute(row.idx, 'finalDestination', e.target.checked)}
      disabled={this.isExpandableRow(row) || this.props.disabled}
    />);
  }

  deleteButton = (value, field, extra, idx) => {
    if (this.props.hasLinks || this.isExpandableRow(field)) {
      return '';
    }
    return (<div>
      <ButtonWithFuncBound
        bsStyle="link"
        style={{ padding: '4px 5px 3px 5px' }}
        className="btn-link-no-underline-on-hover"
        boundFunc={this.showModalDeleteNode}
        args={[idx]}
        disabled={this.props.disabled}
      >
        <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
      </ButtonWithFuncBound>
    </div>);
  }

  dealLink = (idx, quantity) => {
    this.handleChangeRoute(idx, 'linkCreation', true);
    this.props.saveProductToLinkIdx();
    this.props.startAtomsLinking(quantity);
  };

  transportLink = (idx, quantity) => {
    this.handleChangeRoute(idx, 'linkCreation', true);
    this.props.saveProductToLinkTransportIdx();
    this.props.saveLinkIdxToAssignTransport(quantity);
  };

  operationFormatter = (value, row) => {
    if (this.props.hasLinks) {
      return '';
    }
    if (row.finalDestination) {
      return (
        <div>
          <Button
            disabled={this.props.disabled || !row.quantity}
            bsStyle="link"
            style={{ padding: 0, height: 27, width: '100%' }}
            onClick={() => this.dealLink(value, row.quantity)}
          >
            <Glyphicon
              style={{ fontSize: '18px' }}
              glyph="link"
              title="Add link"
            />
          </Button>
          <Button
            disabled={this.props.disabled || !row.quantity}
            bsStyle="link"
            onClick={() => this.transportLink(value, row.quantity)}
            style={{ padding: 0, height: 27, width: '100%' }}
          >
            <div
              style={{
                WebkitMaskImage: `url(${vessel})`,
                backgroundColor: '#008cba',
                WebkitMaskSize: 'contain',
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                width: '100%',
                height: '100%',
              }}
            ></div>
          </Button></div>);
    }
    return (<Button
      disabled={row.finalDestination || this.props.disabled}
      bsStyle="link"
      style={{ padding: 0, height: 55, width: '100%' }}
      onClick={() => this.props.addSubElement([...this.getFieldPath(value), 'elements'])}
    >
      <Glyphicon
        style={{ fontSize: 28 }}
        glyph="indent-left"
        title="Add subnode"
      />
    </Button>);
  };

  isExpandableRow = (row) => this.subElements(row).value.length;

  indexedMultiNodalLinks = () => {
    let mnidx = 0;
    return this.props.links.map(l => {
      if (l.get('fromMultiNodal')) {
        return l.set('idx', mnidx++);
      }
      return l;
    });
  };

  getLinks = (row) => {
    let linkElements = [];
    if (row.links && row.links.length) {
      linkElements = [...linkElements, ...this.indexedMultiNodalLinks().filter(link =>
        !!(link.get('fromMultiNodal') && row.links.some(l => l == link.get('id'))))
        .filter(l => !l.get('hidden'))
        .toJS()];
    }
    if (row.linkIdx && row.linkIdx.length) {
      linkElements = [...linkElements, ...this.indexedMultiNodalLinks().filter(link =>
        !!(link.get('fromMultiNodal') && row.linkIdx.some(l => l == link.get('idx'))))
        .filter(l => !l.get('hidden'))
        .toJS()];
    }
    return linkElements;
  };

  subElements = (row) => ((row.elements && row.elements.length) ?
    { value: row.elements, hasLinks: false }
    : { value: this.getLinks(row), hasLinks: true });

  hasInnerLevels = () => this.props.data.toJS().some(d => this.isExpandableRow(d));

  expandComponent = (row) => {
    const subElements = this.subElements(row);
    return (<MultiNodalRouteTableComponent
      {...this.props}
      parent={row}
      data={fromJS(subElements.value)} hasLinks={subElements.hasLinks}
      parentIdxChain={[...this.getParentIdxChain(), row.idx]}
    />);
  }
  render() {
    return (
      <div className={'deal-payments-tab'}>
        <Modal
          bsSize="small"
          show={this.state.showModalDeleteNode}
          onHide={this.closeModalDeleteNode}
        >
          <Modal.Body>
            Are you sure you want to delete the node?
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.handleDeleteNode}>Yes</Button>
            <Button onClick={this.closeModalDeleteNode}>No</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          bsSize="small"
          show={this.state.showModalDeleteRoute}
          onHide={this.closeModalDeleteRoute}
        >
          <Modal.Body>
            Are you sure you want to delete the route?
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.handleDeleteRoute}>Yes</Button>
            <Button onClick={this.closeModalDeleteRoute}>No</Button>
          </Modal.Footer>
        </Modal>
        <BootstrapTable
          data={this.props.data.map((e, idx) =>
            e.set('key', e.get('creationDate') || e.get('id')).set('idx', idx)).toJS()}
          headerContainerClass={this.props.parent || this.props.hasLinks ? 'hidden' : ''}
          options={{
            expandBy: 'column',
            expanding: expandHack,
            expandBodyClass: 'sub-row',
          }}
          expandableRow={this.isExpandableRow}
          expandComponent={this.expandComponent}
          keyField={'idx'}
          className={'multi-nodal-table'}
          headerStyle={!this.props.viewHeader ? { display: 'none' } : {}}
        >
          <TableHeaderColumn
            expandable={false}
            dataField="idx"
            tdStyle={{ padding: 0, whiteSpace: 'normal' }}
            dataAlign="center" headerAlign="center"
            dataFormat={this.operationFormatter}
            width={'45px'}
          />
          <TableHeaderColumn
            expandable={false}
            dataField={'finalDestination'}
            dataAlign="center" headerAlign="center"
            dataFormat={this.finalDestinationFormatter}
            width={60}
          >
            Final dest.
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataField="destinationFrom"
            dataAlign="left" headerAlign="center"
            formatExtraData="destinationFrom"
            dataFormat={this.textFormatter}
          >
            From
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataAlign="left" headerAlign="center"
            dataField="shipmentStart"
            dataFormat={this.dateFormatter}
            formatExtraData="shipmentStart"
            width={'130px'}
          >
            Transshipment Date
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}

            dataField="destinationTo"
            dataAlign="left" headerAlign="center"
            formatExtraData="destinationTo"
            dataFormat={this.textFormatter}
          >
            To
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataField="term"
            dataAlign="left" headerAlign="center"
            dataFormat={this.termFormatter}
          >
            Incoterm
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataField="mode"
            width={'130px'}
            dataAlign="left" headerAlign="center"
            formatExtraData="mode"
            dataFormat={this.transportTypeFormatter}
          >
            Mode
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataField="carrier"
            dataAlign="left" headerAlign="center"
            formatExtraData="carrier"
            dataFormat={this.textFormatter}
            width={'140px'}
          >
            Carrier
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataField="blDate"
            dataAlign="left" headerAlign="center"
            dataFormat={this.dateFormatter}
            formatExtraData="blDate"
            width={'130px'}
          >
            BL Date
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataField="quantity"
            dataAlign="left" headerAlign="center"
            dataFormat={this.qtyFormatter}
          >
            Qty
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataField="costEstimated"
            formatExtraData="costEstimated"
            dataAlign="left" headerAlign="center"
            dataFormat={this.costFormatter}
            width={'140px'}
          >
            Cost Estimated
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataField="costActual"
            formatExtraData="costActual"
            dataAlign="left" headerAlign="center"
            dataFormat={this.costFormatter}
            width={'100px'}
          >
            Cost Actual
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataField="voyageNumber"
            formatExtraData="voyageNumber"
            dataAlign="left" headerAlign="center"
            dataFormat={this.voyageDaysFormatter}
            width={'80px'}
          >
            Voyage days
          </TableHeaderColumn>
          <TableHeaderColumn
            expandable={false}
            dataAlign="center" headerAlign="center"
            dataFormat={this.arrivalFormatter}
            width={'100px'}
          >
            Arrival
          </TableHeaderColumn>
          {!this.props.viewMode && <TableHeaderColumn
            dataField="idx"
            dataAlign="center" headerAlign="center"
            width="45px"
            expandable={false}
            dataFormat={this.deleteButton}
          />}
        </BootstrapTable>
      </div>);
  }
}

const MultiNodalRouteTableComponent = connect((state, props) => ({
  data: props.data || state.getIn(['data', 'deals', 'deal', 'products', props.productIdx,
    'multiNodalRoutes', props.routeIdx, 'nodes'], new Map()),
  links: props.links || state.getIn(['data', 'deals', 'deal', 'products',
    props.productIdx, 'purchaseLink'], new List()),
  transports: state.getIn(['data', 'deals', 'list', 'transport'],
    new List()),
}), (dispatch, props) => ({
  addSubElement(fieldPath = []) {
    addRouteSubElement(dispatch, props.productIdx, props.routeIdx, fieldPath);
  },
  updateRoute(value, fieldPath = []) {
    updateDealProductField(dispatch, 'purchase', props.productIdx, ['multiNodalRoutes',
      props.routeIdx, 'nodes', ...fieldPath], value);
  },
  updateRouteRecalc(value, fieldPath = []) {
    if (!fieldPath.length && !value.size) {
      deleteMultiNodalRoute(dispatch, 'purchase', props.productIdx, props.routeIdx,
        props.transshipmentExpense, fieldPath);
    } else {
      updateMultiNodalFieldField(dispatch, 'purchase', props.productIdx, ['multiNodalRoutes',
        props.routeIdx, 'nodes', ...fieldPath], value, props.transshipmentExpense);
    }
    handleFormChanged(dispatch);
  },
  deleteMultiNodalRoute(fieldPath = []) {
    if (!fieldPath.length) {
      deleteMultiNodalRoute(dispatch, 'purchase', props.productIdx, props.routeIdx,
        props.transshipmentExpense, fieldPath);
    } else {
      updateMultiNodalFieldField(dispatch, 'purchase', props.productIdx, ['multiNodalRoutes',
        props.routeIdx, 'nodes', ...fieldPath, 'elements'], [], props.transshipmentExpense);
    }
    handleFormChanged(dispatch);
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
  saveProductToLinkIdx() {
    saveProductToLinkIdx(dispatch, props.productIdx);
  },
  saveProductToLinkTransportIdx() {
    saveProductToLinkTransportIdx(dispatch, props.productIdx);
  },
  saveLinkIdxToAssignTransport(fromMultiNodal) {
    saveLinkIdxToAssignTransport(dispatch, props.productIdx, undefined,
      undefined, false, fromMultiNodal);
  },
  deleteLink(linkIdx) {
    deleteLink(dispatch, props.productIdx, linkIdx);
  },
}))(MultiNodalRouteTable);
export default MultiNodalRouteTableComponent;
